// import { NodoPlano } from '../domain/nodoPlano';
import { NodoPlano } from 'interiores-mapa';
import { Contenido } from './Contenido';
import { BalizaFormulario_lite } from './BalizaFormulario_lite';

export class NodoFormulario {
	Id: string;
	Nombre: string;
	Descripcion: string;
	CalidadNumBeaconsMin: Number;
	CalidadPotenciaTxMin: Number;
	EsPDI: Boolean;
	X: Number;
	Y: Number;
	Latitud: Number;
	Longitud: Number;
	RutaImagenPDI: string;
	MostrarEnIndicacionesIntermedias: Boolean;
	IdTipologia: string;
	IdSeccion: string;
	NombreSeccion: string;
	EsPortal: Boolean;
	EsEntrada: Boolean;

	numeroCONTENIDOS: Number = 0;
	contenidosAsociados: Contenido[];
	resumenContenidosAsociados = [];
	tiposContenidosAsociados: any[];

	TIPOLOGIA_NODO: any;
	IconoRepresentacion: string;

	NODO_PLANO: NodoPlano = NodoPlano.createInstance();
	Idiomas: Map<string, NodoIdiomaFormulario> = new Map<string, NodoIdiomaFormulario>();

	// Objeto de Breeze
	ENTIDAD: any;
	TIPO: string;

	balizas: BalizaFormulario_lite[];

	constructor() {
		this.Nombre = '';
		this.Descripcion = '';

		this.Id = '';
		this.Nombre = '';
		this.Descripcion = '';
		this.CalidadNumBeaconsMin = 0;
		this.CalidadPotenciaTxMin = 0;
		this.EsPDI = false;
		this.X = 0;
		this.Y = 0;
		this.Latitud = 0;
		this.Longitud = 0;
		this.RutaImagenPDI = '';
		this.MostrarEnIndicacionesIntermedias = false;
		this.IdTipologia = '';
		this.IdSeccion = '';
		this.NombreSeccion = '';
		this.EsPortal = false;
		this.EsEntrada = false;
		this.contenidosAsociados = [];
		this.tiposContenidosAsociados = [];
		this.NODO_PLANO = NodoPlano.createInstance();
		this.ENTIDAD = {};
		this.balizas = [];

		this.IconoRepresentacion = 'assets/itsoft/IconosSVG/SVG/tipologia-nodo.svg';

		return this;
	}

	fromNodoPlano(nodoPlano: NodoPlano): NodoFormulario{
		this.NODO_PLANO = nodoPlano;

		if (this.NODO_PLANO.ENTIDAD) {
			return this.fromENTIDAD(this.NODO_PLANO.ENTIDAD);
		}

		return this;
	}

	fromENTIDAD(ENTIDAD: any): NodoFormulario{
		this.ENTIDAD = ENTIDAD;
		this.Id = this.ENTIDAD.Id;
		this.Nombre = this.ENTIDAD.Nombre;
		this.Descripcion = this.ENTIDAD.Descripcion;
		this.CalidadNumBeaconsMin = this.ENTIDAD.CalidadNumBeaconsMin;
		this.CalidadPotenciaTxMin = this.ENTIDAD.CalidadPotenciaTxMin;
		this.EsPDI = this.ENTIDAD.EsPDI;
		this.X = this.ENTIDAD.X;
		this.Y = this.ENTIDAD.Y;
		this.Latitud = this.ENTIDAD.Latitud;
		this.Longitud = this.ENTIDAD.Longitud;
		this.RutaImagenPDI = this.ENTIDAD.RutaImagenPDI;
		this.MostrarEnIndicacionesIntermedias = this.ENTIDAD.mostrarEnIndicacionesIntermedias;
		this.IdTipologia = this.ENTIDAD.IdTipologia;
		this.IdSeccion = this.ENTIDAD.IdSeccion;
		this.NombreSeccion = this.ENTIDAD.SECCION ? this.ENTIDAD.SECCION.Nombre : '';
		this.EsPortal = this.ENTIDAD.EsPortal;
		this.EsEntrada = this.ENTIDAD.EsEntrada;

		this.TIPOLOGIA_NODO = this.ENTIDAD.TIPOLOGIA_NODO;
		if (this.TIPOLOGIA_NODO) {
			this.IconoRepresentacion = this.TIPOLOGIA_NODO.IconoRepresentacion;
		}

		this.TIPO = this.ENTIDAD.constructor.name.split('_', 2)[0];

		this.ENTIDAD.IDIOMAS.forEach(element => {
			const aux = new NodoIdiomaFormulario(element);
			this.Idiomas.set(element.IDIOMA.Codigo, aux);
		});

		if (this.ENTIDAD.BALIZAS) {
			this.ENTIDAD.BALIZAS.forEach(nodo_has_baliza => {
				if (nodo_has_baliza.BALIZA) {
					const baliza: BalizaFormulario_lite = new BalizaFormulario_lite().fromENTIDAD(nodo_has_baliza.BALIZA);
					this.balizas.push(baliza);
				}
			});
		}

		if (this.ENTIDAD.CONTENIDOS) {
			this.numeroCONTENIDOS = this.ENTIDAD.CONTENIDOS.length;
			this.ENTIDAD.CONTENIDOS.forEach(cont => {
				if (cont.CONTENIDO) {

					const now = new Date();
					const baja = cont.CONTENIDO.FechaBaja;

					// Solo contamos los contenidos no caducados
					if ( baja === null || now.getTime() <= baja.getTime()) {
						const contenido = new Contenido().fromENTIDAD(cont.CONTENIDO);
						this.contenidosAsociados.push(contenido);

						const aux = this.resumenContenidosAsociados.filter( t => t.Tipo === contenido.TIPOLOGIA_CONTENIDO.Nombre);
						if (aux && aux[0]) {
							const contenido_aux = aux[0];
							contenido_aux.Cantidad = contenido_aux.Cantidad + 1;
						}
						else{
							this.resumenContenidosAsociados.push({
								Tipo: contenido.TIPOLOGIA_CONTENIDO.Nombre,
								IconoRepresentacion: contenido.TIPOLOGIA_CONTENIDO.IconoRepresentacion,
								Cantidad: 1
							});
						}
					}
				}
			});
		}
		return this;
	}
}

export class NodoFormulario_lite {

	Id: string;
	Nombre: string;
	Descripcion: string;
	CalidadNumBeaconsMin: Number;
	CalidadPotenciaTxMin: Number;
	EsPDI: Boolean;
	X: Number;
	Y: Number;
	Latitud: Number;
	Longitud: Number;
	RutaImagenPDI: string;
	MostrarEnIndicacionesIntermedias: Boolean;
	IdTipologia: string;
	IdSeccion: string;
	NombreSeccion: string;
	EsPortal: Boolean;
	EsEntrada: Boolean;

	numeroCONTENIDOS: Number = 0;
	contenidosAsociados: Contenido[];
	resumenContenidosAsociados = [];
	tiposContenidosAsociados: any[];

	TIPOLOGIA_NODO: any;
	IconoRepresentacion: string;

	NODO_PLANO: NodoPlano = NodoPlano.createInstance();
	Idiomas: Map<string, NodoIdiomaFormulario> = new Map<string, NodoIdiomaFormulario>();

	// Objeto de Breeze
	ENTIDAD: any;
	TIPO: string;

	balizas: BalizaFormulario_lite[];

	fromENTIDAD(ENTIDAD: any): NodoFormulario_lite{
		this.ENTIDAD = ENTIDAD;
		this.Id = this.ENTIDAD.Id;
		this.Nombre = this.ENTIDAD.Nombre;
		this.Descripcion = this.ENTIDAD.Descripcion;
		this.CalidadNumBeaconsMin = this.ENTIDAD.CalidadNumBeaconsMin;
		this.CalidadPotenciaTxMin = this.ENTIDAD.CalidadPotenciaTxMin;
		this.EsPDI = this.ENTIDAD.EsPDI;
		this.X = this.ENTIDAD.X;
		this.Y = this.ENTIDAD.Y;
		this.Latitud = this.ENTIDAD.Latitud;
		this.Longitud = this.ENTIDAD.Longitud;
		this.RutaImagenPDI = this.ENTIDAD.RutaImagenPDI;
		this.MostrarEnIndicacionesIntermedias = this.ENTIDAD.mostrarEnIndicacionesIntermedias;
		this.IdTipologia = this.ENTIDAD.IdTipologia;
		this.IdSeccion = this.ENTIDAD.IdSeccion;
		this.NombreSeccion = this.ENTIDAD.SECCION ? this.ENTIDAD.SECCION.Nombre : '';
		this.EsPortal = this.ENTIDAD.EsPortal;
		this.EsEntrada = this.ENTIDAD.EsEntrada;

		this.TIPOLOGIA_NODO = this.ENTIDAD.TIPOLOGIA_NODO;
		if (this.TIPOLOGIA_NODO) {
			this.IconoRepresentacion = this.TIPOLOGIA_NODO.IconoRepresentacion;
		}

		this.TIPO = this.ENTIDAD.constructor.name.split('_', 2)[0];
		this.ENTIDAD.IDIOMAS.forEach(element => {
			const aux = new NodoIdiomaFormulario(element);
			this.Idiomas.set(element.IDIOMA.Codigo, aux);
		});
		return this;
	}
}


export class NodoIdiomaFormulario {

	Codigo: string = '';
	Nombre: string = '';
	Descripcion: string = '';
	NombreSeccion: string ='';
	// TextoContenidos: string;

	constructor(nodoIdioma?) {

		if (nodoIdioma) {
			this.Codigo = nodoIdioma.IDIOMA.Codigo ? nodoIdioma.IDIOMA.Codigo : '';
			this.Nombre = nodoIdioma.Nombre ? nodoIdioma.Nombre : '';
			this.Descripcion = nodoIdioma.Descripcion ? nodoIdioma.Descripcion : '';
			this.NombreSeccion = nodoIdioma.NombreSeccion ? nodoIdioma.NombreSeccion : '';
		}
		else{
			this.Codigo = '';
			this.Nombre = '';
			this.Descripcion = '';
			this.NombreSeccion='';
		}

	 }
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/NodoFormulario.ts